import { forwardRef } from 'react'
import ToolTip from '../trustyle-tool-tip'

const SimpleRadio = forwardRef((props, ref) => (
  <label sx={{ display: 'block', mr: 'md', width: '100%', variant: 'elements.simple-radio.label' }}>
    <input
      sx={{
        appearance: 'none',
        position: 'absolute',
        '&:checked + span': {
          '&::before': {
            transition: 'background-color 200ms, border-color 200ms',
          },
        },
        variant: 'elements.input.radio.base',
      }}
      type='radio'
      name={props.name}
      value={props.value}
      ref={ref}
      onClick={props.onClick}
      defaultChecked={props.defaultChecked}
      label={props.label}
    />
    <span
      sx={{
        variant: props.hasError
          ? 'elements.simple-radio.variants.error'
          : 'elements.simple-radio.span',
      }}
    >
      <div sx={{ display: 'flex', flexGrow: '1', justifyContent: 'space-between' }}>
        {props.label}
        <If condition={props.toolTip}>
          <ToolTip content={props.toolTip.content} title={props.toolTip.title} variant={'radio'} />
        </If>
      </div>
    </span>
  </label>
))

export default SimpleRadio
